import { updateUserOptions, updateUserConfiguration } from 'owa-options-core';
import toggleDarkModeThemeAction from '../actions/toggleDarkModeTheme';
import { orchestrator } from 'satcheljs';
import previewDarkModeTheme from './previewDarkModeTheme';

export default async function commitDarkModeTheme(isDarkModeTheme: boolean) {
    previewDarkModeTheme(isDarkModeTheme);

    updateUserOptions({ IsDarkModeTheme: isDarkModeTheme });

    await updateUserConfiguration([
        {
            propertyName: 'isDarkModeTheme',
            propertyType: 'Boolean',
            propertyValue: `${isDarkModeTheme}`,
        },
    ]);
}

orchestrator(toggleDarkModeThemeAction, msg => commitDarkModeTheme(msg.isDarkModeEnabled));
